import { LuChevronDown } from 'react-icons/lu';
import { ImageWithFallback } from './figma/image-with-fallback';
import { motion } from "framer-motion";

export function LoyalCustomerSection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="h-screen snap-start flex flex-col bg-white px-5 py-12">
      <motion.div
        className="flex-1 flex flex-col items-center justify-center max-w-2xl mx-auto w-full"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
      >
        <motion.h1
          variants={itemVariants}
          className="text-center mb-16"
          style={{ fontSize: '2.25rem', fontWeight: 800, lineHeight: 1.3 }}
        >
          '단골'로 이어집니다
        </motion.h1>
        
        <motion.div
          variants={itemVariants}
          className="w-full bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl overflow-hidden shadow-xl mb-6"
        >
          <div className="relative w-full h-48">
            <ImageWithFallback
              src="https://cdn-mahi.com/two_user.png"
              alt="단골 고객"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent" />
          </div>
          
          <div className="p-8">
            <div className="text-center mb-6">
              <p className="text-white/90 mb-4" style={{ fontSize: '1.125rem', fontWeight: 600 }}>
                마감히어로에서 구매한 고객 중
              </p>
              <div className="text-white mb-4" style={{ fontSize: '3.5rem', fontWeight: 900, lineHeight: 1 }}>
                2명 중 1명
              </div>
            </div>
            
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6">
              <p className="text-white text-center" style={{ fontSize: '1.125rem', fontWeight: 700, lineHeight: 1.6 }}>
                이후 매장을<br />
                다시 방문해요
              </p>
            </div>
          </div>
        </motion.div>
        
        <motion.div variants={itemVariants}>
          <LuChevronDown className="w-6 h-6 text-gray-400 animate-bounce" />
        </motion.div>
      </motion.div>
    </section>
  );
}
